import styled from 'styled-components';
import { titleH3 } from '../../styles/TextSizes';
import { device } from '../../styles/Responsive';

export const SectionContainer = styled.div`
  margin-bottom: 80px;
  padding: 0px 15px;
  width: 100%;

  @media ${device.desktop} {
    margin-bottom: 60px;
  }

  @media ${device.tablet} {
    margin-bottom: 40px;
  }
`;

export const Title = styled(titleH3)`
  text-align: left;
  margin-bottom: 20px;
`;

export const Description = styled.div`
  text-align: left;
`;

export const PendingValidationBanner = styled.div`
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 4px;
  padding: 10px 14px;
  margin-bottom: 16px;
  color: #d48806;
  font-size: 14px;
  text-align: left;
`;